(function () {
    'use strict';

    angular.module('pages.base', ['base.product-updates', 'pages.base.terms']);
})();
